module.exports = __webpack_public_path__ + "img/1 (100).7977eb99.png";